<script>
export default {
  name: "vendor_sites_name",
  props: {
    wastesOrServiceBySchedule: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    names() {
      let nameArray = 
       this.wastesOrServiceBySchedule.map(waste_or_services_by_schedule => {
        return waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name;
      }).filter(x => !!x);
      let nameSet = new Set(nameArray);
      return Array.from(nameSet).join('<br>');
    },
  }
}
</script>

<template>
  <div v-if="names" v-html="names" class="content-area"></div>
</template>

<style scoped lang="scss">
.content-area {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
</style>
